"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowUpCircle = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ArrowUpCircle = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M24 12c0 6.627-5.373 12-12 12A12 12 0 010 12C0 5.373 5.373 0 12 0s12 5.373 12 12zM11.568 8.58l-3.6 3.6A.6.6 0 008.4 13.2h7.2a.6.6 0 00.42-1.02l-3.6-3.6a.612.612 0 00-.852 0z", clipRule: "evenodd" })); };
exports.ArrowUpCircle = ArrowUpCircle;
//# sourceMappingURL=arrow-up-circle.js.map